if (!customElements.get('hl-stack-renders')) {
  customElements.define('hl-stack-renders', class extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('[data-hlst-component]')].map(card => ({
        card,
        index: Number(card.dataset.hlstOptionIndex),
        choices: JSON.parse(card.querySelector('[data-hlst-render-options]').textContent)
      }));
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const productInfo = document.querySelector('product-info[data-update-url="true"]');
        if (!productInfo || data.sectionId !== productInfo.dataset.section || !data.variant) return;
        this.update(data.variant.options);
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    update(options) {
      this.cards.forEach(({card, index, choices}) => {
        if (index < 0) return;
        const choice = choices.find(entry => entry.title === options[index]);
        if (!choice) return;
        const img = card.querySelector('.hlst-component-image img, .hlst-hero-render');
        if (img) {
          img.srcset = `${choice.small} 200w, ${choice.medium} 400w, ${choice.src} ${card.closest('.hlst-hero') ? 800 : 600}w`;
          img.src = choice.src;
          img.alt = choice.alt;
        }
        card.querySelectorAll('.hlst-component-image, h3 a, .hlst-product-link, .hlst-hero-link').forEach(link => { link.href = choice.url; });
      });
    }
  });
}
